import type { NextPage } from 'next'
import { LabelLibrary } from '@/client/modules/LabelLibrary'
import { IPersonalInfos } from '@/client/modules/PersonalInfos/types'
import { getCMSContent } from '@/client/utils'
import { IRoutes } from '@/client/utils/routes/types'

const LabelLibraryPage: NextPage<any> = () => <></>

// export async function getStaticProps({ defaultLocale, locale }) {
//   return {
//     revalidate: 10,
//     redirect: {
//       destination: '/my-account/label-library/myorder-files',
//       permanent: false
//       // statusCode: 301
//     }
//   }
// }

export default LabelLibraryPage
